import request from '@utils/request'
import { ReturnType } from './types'

const get = async (params: any) => {
  try {
    const config: ReturnType = {
      url: 'transactions',
      method: 'get',
      params,
      authorization: true,
      config: {
        showErr: true,
        store: {
          action: 'set',
          key: 'transaction',
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err.message)
  }
}

export default {
  get,
}
